export interface CheckoutPhone {
  preferred: boolean;
  type: string;
  usage: string;
  value: string;
}
